import React from 'react';
import { RiArchiveLine as RiRefreshLine, RiUserAddLine, RiCheckboxCircleLine as RiPackageCheckLine,RiErrorWarningLine as RiAlertTriangleLine } from 'react-icons/ri';
import './ActivityItem.css';

const icons = {
  refresh: RiRefreshLine,
  user: RiUserAddLine,
  check: RiPackageCheckLine,
  alert: RiAlertTriangleLine,
};

const ActivityItem = ({ type, title, subtitle }) => {
  const Icon = icons[type] || RiRefreshLine;

  let bgColor = 'rgba(232, 213, 160, 0.3)';
  if (type === 'user') bgColor = 'rgba(139, 126, 111, 0.1)';
  if (type === 'check') bgColor = 'rgba(203, 227, 195, 0.4)';
  if (type === 'alert') bgColor = 'rgba(244, 209, 198, 0.4)';

  return (
    <div className="activity-item">
      <div className="activity-icon" style={{ backgroundColor: bgColor }}>
        <Icon size={16} />
      </div>
      <div className="activity-content">
        <div className="activity-title">{title}</div>
        <div className="activity-subtitle">{subtitle}</div>
      </div>
    </div>
  );
};

export default ActivityItem;